import CurrencyTypes from '../types/CurrencyTypes';

const initialState = {
  isLoading: false,
  currencyData: [],
  currenciesAllItem: [],
  currencyItemData: {},
  currencyActiveData: [],
  queryParams: {
    paginationData: { page: 0, pageSize: 10 },
    sortingData: { sortField: '', sort: '' },
    keyword: ''
  }
};

// eslint-disable-next-line default-param-last
const currency = (state = initialState, action) => {
  switch (action.type) {
    case CurrencyTypes.GET_CURRENCY_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case CurrencyTypes.GET_CURRENCY_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        currencyData: action.payload
      };
    case CurrencyTypes.GET_CURRENCY_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        currencyData: []
      };

    case CurrencyTypes.GET_ALL_CURRENCY_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case CurrencyTypes.GET_ALL_CURRENCY_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        currenciesAllItem: action.payload
      };
    case CurrencyTypes.GET_ALL_CURRENCY_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        currenciesAllItem: []
      };

    case CurrencyTypes.GET_CURRENCY_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case CurrencyTypes.GET_CURRENCY_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        currencyItemData: action.payload
      };
    case CurrencyTypes.GET_CURRENCY_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
        currencyItemData: []
      };
    case CurrencyTypes.GET_CURRENCY_ACTIVE_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case CurrencyTypes.GET_CURRENCY_ACTIVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        currencyActiveData: action.payload
      };
    case CurrencyTypes.GET_CURRENCY_ACTIVE_ERROR:
      return {
        ...state,
        isLoading: false,
        currencyActiveData: []
      };

    case CurrencyTypes.UPDATE_CURRENCY_QUERY_PARAMS:
      return {
        ...state,
        queryParams: {
          // ...state.queryParams,
          paginationData: action.payload.paging,
          sortingData: action.payload.sorting,
          keyword: action.payload.keyword
        }
      };

    default:
      return state;
  }
};
export default currency;
